module.exports = __webpack_public_path__ + "img/rmg-white-logo-new.7bf1fb19.png";